<template>
  <div class="container-fluid">
    <div v-if="typeControlPermission">
      <div class="row">
        <div class="col">
          <Topbar v-if="defaultval.state=='Y' " ref="con1" @inid="inid" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Bottombar v-if="defaultval.state=='Y' " ref="con2" />
        </div>
      </div>
      <div v-if="defaultval.state=='N'">
        <a-result  status="warning" title="請確認該組織,是否已經通過審核.">
          <template #extra>
          </template>
        </a-result>
      </div>
    </div>
    <span v-else v-text="'您沒有管理權限'"></span>
  </div>        
</template>
<script>
import { mapState } from "vuex";
import Topbar from "./contant/Check_topbar.vue"
import Bottombar from "./contant/Check_bottomtbar.vue"


export default {
  name: 'Check_orglist',   
  components: {
    Topbar,
    Bottombar,
  },
  data() {
    return {
      data: [],
    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState("makeorg", ["datas","defaultval"]),
      typeControlPermission() {
        const currentVal = this.$route.name;
        //Check_orglist
        // 取得 acts_permissions 陣列，從 defaultval.permissions.acts_permissions
        const acts_permissions = this.defaultval?.permissions?.acts_permissions || [];
        // 找到 vals 為 Advancementoption 的主功能
        const adv = acts_permissions.find(item => item.vals === "Advancementoption");
        if (!adv) return null;
        // 在其 acts_detailpermission 裡找 vals 為 Type_control 的細項
        return adv.acts_detailpermission.find(d => d.vals === currentVal) || null;
      }      
  },
  mounted() {

  },
  methods: {
    inid(){
      this.$refs["con2"].inid()
    }
  },
};
</script>